const data = [
    {
        roles:[
            "Operations",
            "Contact Center",
            "Digital Experience and Ecommerce",
            "Service Executive"
        ],
        title: "Oracle Service website",
        description: "Give your customers the service they want, when and where they need it, with powerful and intelligent B2B, B2C, and field solutions. Predict the need for service, automate processes, and deliver tailored responses while balancing self-service and assisted service models.",
        image: "tbnail-01.png",
        cta_text:"Learn more about Oracle Service",
        url:"https://www.oracle.com/cx/service/"
    },
    {
        roles:[
            "Operations",
            "Contact Center",
            "Digital Experience and Ecommerce",
            "Service Executive"
        ],
        title: "Video: Oracle Service",
        description: "Know your customers, predict their needs, and give them the service they expect. From self-service to live agent, knowledge articles to intelligent advice, video chat to field service, and everything in between, Oracle Service is here for your customer service needs.",
        image: "tbnail-02.png",
        cta_text:"Explore Oracle Service",
        url:"https://www.youtube.com/watch?v=m1B87v_YxHY"
    },
    {
        roles:[
            "Field Service"
        ],
        title: "Oracle Field Service website",
        description: "Optimize field technician scheduling to maximize resource utilization. Ensure technicians (your own or third-party) with the right skills and parts arrive on time to solve customer issues the first time to improve CSAT and increase service margins.",
        image: "tbnail-03.png",
        cta_text:"Learn more about Oracle Field Service",
        url:"https://www.oracle.com/cx/service/field-service-management/"
    },
    {
        roles:[
            "Field Service"
        ],
        title: "Product Tour: Oracle Field Service",
        description: "See how Oracle Field Service improves field service management with intuitive, AI-powered tools for routing, scheduling, and managing field service activities. View mobile capabilities to support field technicians and improve first time fix rates.",
        image: "tbnail-04.png",
        cta_text:"Explore Oracle Field Service",
        url:"https://www.oracle.com/webfolder/s/quicktours/cx/gqt-cx-fs-overview/index.html"
    },
]

export default data;